<app-ion-common-header [id]="headerId" (backHeader)="back()" [title]="titlePage"
                       [isDark]="true" ></app-ion-common-header>

<ion-content>
  <div class="content-list content-scroll" >
    
    <div class="block">
      <ion-list  >
        <ion-radio-group [value]="valueContaIonDomainOrigin" (ionChange)="changeContaIonDomainOrigin($event)">
          <ion-list-header>
            <ion-label color="secondary">contaIonDomainOrigin</ion-label>
          </ion-list-header>

          <ion-item >
            <ion-label color="secondary">Mock</ion-label>
            <ion-radio  slot="start" value="Mock"></ion-radio>
          </ion-item>

          <ion-item>
            <ion-label color="secondary">UserDomainCaronte</ion-label>
            <ion-radio slot="start" value="UserDomainCaronte"></ion-radio>
          </ion-item>

          <ion-item>
            <ion-label color="secondary">UserDomainMobile</ion-label>
            <ion-radio slot="start" value="UserDomainMobile"></ion-radio>
          </ion-item>

          <ion-item>
            <ion-label color="secondary">BrokerMobile</ion-label>
            <ion-radio slot="start" value="BrokerMobile"></ion-radio>
          </ion-item>

          <ion-item>
            <ion-label color="secondary">BrokerCaronte</ion-label>
            <ion-radio slot="start" value="BrokerCaronte"></ion-radio>
          </ion-item>
        </ion-radio-group>
      </ion-list>
    </div>

    <div class="block">
      <ion-list>
        <ion-radio-group [value]="valueContaIonDomainCityOrigin">
          <ion-list-header>
            <ion-label color="secondary">contaIonDomainCityOrigin</ion-label>
          </ion-list-header>

          <ion-item>
            <ion-label color="secondary">Mock</ion-label>
            <ion-radio slot="start" value="Mock"></ion-radio>
          </ion-item>

          <ion-item>
            <ion-label color="secondary">UserDomainCaronte</ion-label>
            <ion-radio slot="start" value="UserDomainCaronte"></ion-radio>
          </ion-item>

          <ion-item>
            <ion-label color="secondary">UserDomainMobile</ion-label>
            <ion-radio slot="start" value="UserDomainMobile"></ion-radio>
          </ion-item>

          <ion-item>
            <ion-label color="secondary">BrokerMobile</ion-label>
            <ion-radio slot="start" value="BrokerMobile"></ion-radio>
          </ion-item>

          <ion-item>
            <ion-label color="secondary">BrokerCaronte</ion-label>
            <ion-radio slot="start" value="BrokerCaronte"></ion-radio>
          </ion-item>
        </ion-radio-group>
      </ion-list>
    </div>

    <div class="block">
      <ion-list>
        <ion-radio-group [value]="valueContaIonDataOrigin">
          <ion-list-header>
            <ion-label color="secondary">contaIonDomainCityOrigin</ion-label>
          </ion-list-header>

          <ion-item>
            <ion-label color="secondary">Mock</ion-label>
            <ion-radio slot="start" value="Mock"></ion-radio>
          </ion-item>

          <ion-item>
            <ion-label color="secondary">Mobile</ion-label>
            <ion-radio slot="start" value="Mobile"></ion-radio>
          </ion-item>

          <ion-item>
            <ion-label color="secondary">Caronte</ion-label>
            <ion-radio slot="start" value="Caronte"></ion-radio>
          </ion-item>

        </ion-radio-group>
      </ion-list>
    </div>

    <div class="block">
      Env info: {{envInfo}} <br>
      Env info: {{caronteUrl}} <br>
      token: {{token}} <br>
    </div>

    <div class="block">
      <div class="logs-div" *ngFor="let log of logs">
        {{formatTime(log.time)}}
        - ({{log.pointer}}) 
        {{log.message}}
      </div>
    </div>
    
  </div>

</ion-content>
